import { extractShippingViaCompanyId } from "../../../../utils/getConsolidatedValue"
import type { ShipToLocationWithWarehouse } from "../types"

import { useGetPurchaseOrderShipToLocation } from "./useGetPurchaseOrderShipToLocation"

import type { Company } from "@/graphql/codegen/graphql"
import { useGetAssociatedLocations } from "@/screens/Companies/hooks/useGetAssociatedLocations"

interface UseGetStartPurchaseOrderDataReturn {
  shipToLocations: ShipToLocationWithWarehouse[]
  shipToLocationListFetching: boolean
  loadMore: () => void
  shippingViaCompanyId: string | null
}

export const useGetStartPurchaseOrderData = ({
  selectedCompany,
}: {
  selectedCompany?: Company
}): UseGetStartPurchaseOrderDataReturn => {
  const { shipToLocations, shipToLocationListFetching, loadMore } = useGetPurchaseOrderShipToLocation()
  const { associatedLocationList } = useGetAssociatedLocations({
    companyId: selectedCompany?.companyId || "",
  })
  const shippingViaCompanyId = extractShippingViaCompanyId(associatedLocationList)

  return {
    shipToLocations,
    shipToLocationListFetching,
    loadMore,
    shippingViaCompanyId,
  }
}
